import { cloneDeep } from "lodash";
import {
    GET_ANALYSIS_MONOPOLE_ERROR,
    GET_ANALYSIS_MONOPOLE_STARTING,
    GET_ANALYSIS_MONOPOLE_SUCCESS,
} from "../../constants/actionTypes";
import initialState from "../../store/initialState";

export default function analysisMonopoleReducer(
    state = initialState.towerAnalysisMonopole,
    action
) {
    switch (action.type) {
        case GET_ANALYSIS_MONOPOLE_STARTING: {
            const { analysisTypeMonopole, towerId } = action;
            const newState = cloneDeep(state);

            if (!newState[towerId]) {
                newState[towerId] = cloneDeep(initialState.towerAnalysisMonopole.towerId);
            }

            if (!newState[towerId][analysisTypeMonopole]) {
                newState[towerId][analysisTypeMonopole] = cloneDeep(
                    initialState.towerAnalysisMonopole.towerId.analysisTypeMonopole
                );
            }

            const analysisData = newState[towerId][analysisTypeMonopole];
            analysisData.loading = true;
            analysisData.loaded = false;
            return newState;
        }

        case GET_ANALYSIS_MONOPOLE_SUCCESS: {
            const { analysisTypeMonopole, data, towerId } = action;
            const newState = cloneDeep(state);

            if (!newState[towerId]) {
                newState[towerId] = cloneDeep(initialState.towerAnalysisMonopole.towerId);
            }

            if (!newState[towerId][analysisTypeMonopole]) {
                newState[towerId][analysisTypeMonopole] = cloneDeep(
                    initialState.towerAnalysisMonopole.towerId.analysisTypeMonopole
                );
            }

            const analysisData = newState[towerId][analysisTypeMonopole];
            analysisData.loading = false;
            analysisData.loaded = true;
            analysisData.data = data.outputData;
            return newState;
        }

        case GET_ANALYSIS_MONOPOLE_ERROR: {
            const { analysisTypeMonopole, err, towerId } = action;
            const newState = cloneDeep(state);

            if (!newState[towerId]) {
                newState[towerId] = cloneDeep(initialState.towerAnalysisMonopole.towerId);
            }

            if (!newState[towerId][analysisTypeMonopole]) {
                newState[towerId][analysisTypeMonopole] = cloneDeep(
                    initialState.towerAnalysisMonopole.towerId.analysisTypeMonopole
                );
            }

            const analysisData = newState[towerId][analysisTypeMonopole];
            analysisData.loading = true;
            analysisData.loaded = false;
            analysisData.data = err;
            return newState;
        }
        default: {
            return state;
        }
    }
}
